import dynamic from "next/dynamic"

const SanityCaseStudy = dynamic(() => import("./SanityCaseStudy"))
const SanityContactsHero = dynamic(() => import("./SanityContactsHero"))
const SanityDynamicTexts = dynamic(() => import("./SanityDynamicTexts"))
const SanityHero = dynamic(() => import("./SanityHero"))
const SanityHero2 = dynamic(() => import("./SanityHero2"))
const SanityInfoBlock = dynamic(() => import("./SanityInfoBlock"))
const SanityContactForm = dynamic(() => import("./SanityContactForm"))
const SanityFeaturesBlock = dynamic(() => import("./SanityFeaturesBlock"))
const SanityFeaturesBlock2 = dynamic(() => import("./SanityFeaturesBlock2"))
const SanityFeaturesCard = dynamic(() => import("./SanityFeaturesCard"))
const SanityFeaturesContainer = dynamic(
  () => import("./SanityFeaturesContainer")
)
const SanityFeaturesList = dynamic(() => import("./SanityFeaturesList"))
const SanityFeaturesList2 = dynamic(() => import("./SanityFeaturesList2"))
const SanityOfficeLocations = dynamic(() => import("./SanityOfficeLocations"))
const SanityHtmlBlock = dynamic(() => import("./SanityHtmlBlock"))
const SanityItemsList = dynamic(() => import("./SanityItemsList"))
const SanityInfoPanel = dynamic(() => import("./SanityInfoPanel"))
const SanityTextInfo = dynamic(() => import("./SanityTextInfo"))
const SanityContactsMap = dynamic(() => import("./SanityContactsMap"))
const SanityTextBlock = dynamic(() => import("./SanityTextBlock"))
const SanityPageLinks = dynamic(() => import("./SanityPageLinks"))
const SanityMultiCarousel = dynamic(() => import("./SanityMultiCarousel"))
const SanityImageText2 = dynamic(() => import("./SanityImageText2"))

export const BlocksComponents = {
  caseStudyBlock: SanityCaseStudy,
  localizedCaseStudyBlock: SanityCaseStudy,
  localizedContactForm: SanityContactForm,
  contactsMap: SanityContactsMap,
  contactsHero: SanityContactsHero,
  localizedContactsHero: SanityContactsHero,
  dynamicTexts: SanityDynamicTexts,
  localizedDynamicTexts: SanityDynamicTexts,
  hero: SanityHero,
  hero2: SanityHero2,
  localizedHero2: SanityHero2,
  imageText2: SanityImageText2,
  localizedImageText2: SanityImageText2,
  infoBlock: SanityInfoBlock,
  localizedInfoBlock: SanityInfoBlock,
  infoPanel: SanityInfoPanel,
  localizedInfoPanel: SanityInfoPanel,
  itemsList: SanityItemsList,
  localizedItemsList: SanityItemsList,
  featuresBlock: SanityFeaturesBlock,
  featuresBlock2: SanityFeaturesBlock2,
  localizedFeaturesBlock2: SanityFeaturesBlock2,
  featuresContainer: SanityFeaturesContainer,
  localizedFeaturesContainer: SanityFeaturesContainer,
  featuresCard: SanityFeaturesCard,
  localizedFeaturesCard: SanityFeaturesCard,
  featuresList: SanityFeaturesList,
  featuresList2: SanityFeaturesList2,
  localizedFeaturesList2: SanityFeaturesList2,
  htmlBlock: SanityHtmlBlock,
  localizedHtmlBlock: SanityHtmlBlock,
  multiCarousel: SanityMultiCarousel,
  localizedMultiCarousel: SanityMultiCarousel,
  textInfo: SanityTextInfo,
  localizedTextInfo: SanityTextInfo,
  "text-block": SanityTextBlock,
  "office-locations": SanityOfficeLocations,
  localizedOfficeLocations: SanityOfficeLocations,
  pageLinks: SanityPageLinks,
  localizedPageLinks: SanityPageLinks,
}
